module.exports = __webpack_public_path__ + "static/media/nazka-team-1.f0aafa3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/media/nazka-team-1.jpg
// module id = 284
// module chunks = 0